import ImageUtils from '../../utils/image-utils';
import StringUtils from '../../utils/string-utils';
import AnalyticsHelper from '../../utils/analytics-helper';
import { configuratorProperty, groupType } from '../constants/configuratorConstants';

export default class ConflictModal {
    constructor(parent) {
        this.parent = parent;
        this.data = parent.data;
        this.car = parent.car;
        this.pricing = parent.pricing;
        this.navigation = parent.navigation;
        this.leadTime = parent.leadTime;
        this.el = parent.el.querySelector('.configurator--conflict-modal');
        this.content = this.el.querySelector('.modal-content');
        this.confirm = this.el.querySelector('.modal-confirm');
        this.cancel = this.el.querySelector('.modal-cancel');
        this.closeModal = this.el.querySelector('.modal-close');
        this.template = _.template(parent.el.querySelector('#configurator--conflict-modal-template').innerHTML.replaceAll('\\', ''));
        this.utils = { rendition: ImageUtils.rendition };
        this.onConfirm = () => {};
        this.bind();
    }

    bind() {
        this.confirm.addEventListener('click', (e) => {
            e.preventDefault();
            this.onConfirm();
            this.hide();
            this.sendAnalytics('submit');
        });

        this.cancel.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
            this.sendAnalytics('cancel');
        });

        this.closeModal.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
            this.sendAnalytics('cancel');
        });
        this.el.addEventListener('click', (e) => {
            if (!e.target.closest('.modal-container')) {
                this.hide();
            }
        });
    }

    getSelectedItemImage({ choiceId, choiceType }) {
        switch (choiceType) {
        case configuratorProperty.colour: {
            return { hex: this.data.colourMap[choiceId].hex, isColour: true };
        }
        case configuratorProperty.trim: {
            return { image: this.data.trimMap[choiceId].iconImage };
        }
        case configuratorProperty.accessories: {
            return { image: this.data.accessories[choiceId].mainAccImage };
        }
        default:
            return '';
        }
    }

    getSelectedItemPrice({ choiceType, choiceId }) {
        switch (choiceType) {
        case configuratorProperty.id: {
            const mtoPrices = this.pricing.getMTOPrices();
            const { mto } = this.data.carMap[choiceId];
            return this.pricing.format(mtoPrices[mto]);
        }
        case configuratorProperty.colour: {
            const colourPrices = this.pricing.getColourPrices();
            const { mtoce } = this.data.colourMap[choiceId];
            return this.pricing.format(colourPrices[mtoce]);
        }
        case configuratorProperty.trim: {
            const trimPrices = this.pricing.getTrimPrices();
            const { mtoce } = this.data.trimMap[choiceId];
            return this.pricing.format(trimPrices[mtoce]);
        }
        case configuratorProperty.accessories: {
            const { mtoce, groupType: type } = this.data.accessories[choiceId];
            const wheelPrices = this.pricing.getWheelPrices();
            const accessoryPrices = this.pricing.getAccessoryPrices();
            const price = type === groupType.wheels ? wheelPrices[mtoce] : accessoryPrices[mtoce];
            return this.pricing.format(price);
        }
        default:
            return '';
        }
    }

    getSelectedItemTitle({ choiceType, choiceId, tempCar }) {
        switch (choiceType) {
        case configuratorProperty.id: {
            const { gradeName } = this.data.carMap[choiceId];
            const {
                engineName, transmissionName, fuelName, drivetrain,
            } = tempCar.data();
            const subtitle = [engineName, transmissionName, fuelName, drivetrain].filter(Boolean).join(' ');
            return { title: gradeName, subtitle };
        }
        case configuratorProperty.colour: {
            const { name } = this.data.colourMap[choiceId];
            return { title: name };
        }
        case configuratorProperty.trim: {
            const { name } = this.data.trimMap[choiceId];
            return { title: name };
        }
        case configuratorProperty.accessories: {
            const { description } = this.data.accessories[choiceId];
            return { title: description };
        }
        default:
            return {};
        }
    }

    async show(diff, tempCar) {
        await this.pricing.waitForMTOPricing();
        this.modalData = {
            pricing: {
                format: (val) => this.pricing.format(val),
                mtoPrices: this.pricing.getMTOPrices(),
                colourPrices: this.pricing.getColourPrices(),
                trimPrices: this.pricing.getTrimPrices(),
                accessoryPrices: this.pricing.getAccessoryPrices(),
                wheelPrices: this.pricing.getWheelPrices(),
            },
            utils: this.utils,
            diff,
            header: {
                ...this.getSelectedItemTitle({ choiceType: diff.type, choiceId: diff.id, tempCar }),
                ...this.getSelectedItemImage({ choiceType: diff.type, choiceId: diff.id }),
                price: this.getSelectedItemPrice({ choiceType: diff.type, choiceId: diff.id }),
            },
            current: {
                car: this.car,
                data: this.car.data(),
                colourTrim: this.car.colourTrim(),
                accessories: diff.currentAccessories,
                leadTime: this.leadTime.getCarEstimatedMonth(this.car),
            },
            compare: {
                car: tempCar,
                data: tempCar.data(),
                colourTrim: tempCar.colourTrim(),
                accessories: diff.compareAccessories,
                leadTime: this.leadTime.getCarEstimatedMonth(tempCar),
            },
        };

        this.content.innerHTML = this.template(this.modalData);
        this.el.showModal();
        this.el.querySelector('.modal-close').focus({ preventScroll: true });

        const selectedItem = document.querySelector('.selected-item');
        if (selectedItem) {
            selectedItem.scrollIntoView();
        }
        this.el.scrollTop = 0;
        this.sendAnalytics('open');
    }

    hide() {
        this.el.close();
    }

    sendAnalytics(action) {
        AnalyticsHelper.template(this.el, { data: this.modalData, action, sectionName: this.navigation.sectionName });
        AnalyticsHelper.push(this.el);
    }
}
